import { render, staticRenderFns } from "./user-activities-view.vue?vue&type=template&id=5fa5f663&"
import script from "./user-activities-view.vue?vue&type=script&lang=js&"
export * from "./user-activities-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports